<template>
  <div class="updates-content">
    <div class="display-1 font-weight-bold">List of Updates</div>
    <div class="updates">
      <div v-for="(update, index) in updateList">
        <update-card :storeIndex="index"/>
      </div>
    </div>
  </div>
</template>

<script>
import UpdateCard from '../components/UpdateCard';

export default {
  name: 'updates',
  data() {
    return {

    };
  },
  computed: {
    updateList() {
      return this.$store.state.updates;
    },
  },
  components: {
    UpdateCard,
  }
};
</script>

<style>
.updates-content {
  margin: 25px 0% 0 0%;
  text-align: center;
}

.updates {
  display: grid;
  grid-template-columns: 50% 50%;
}
</style>